import { create } from 'zustand';
import { FormData, EstimationType, PropertyType, User } from '@/types';

interface LeadStore {
  currentStep: number;
  formData: FormData;
  addressValidated: boolean;
  
  setEstimationType: (type: EstimationType) => void;
  setPropertyType: (type: PropertyType) => void;
  setAddress: (address: string, validated: boolean, inseeCode?: string) => void;
  setSurface: (surface: number) => void;
  setSurfaceRdc: (surfaceRdc: number) => void;
  setSurfaceSousSol: (surfaceSousSol: number) => void;
  setFloor: (floor: number) => void;
  setIsNewProperty: (isNewProperty: boolean) => void;
  setUser: (user: User) => void;
  nextStep: () => void;
  previousStep: () => void;
  goToStep: (step: number) => void;
  resetForm: () => void;
}

const initialFormData: FormData = {
  estimationType: null,
  propertyType: null,
  address: null,
  inseeCode: null,
  surface: null,
  surfaceRdc: null,
  surfaceSousSol: null,
  floor: null,
  isNewProperty: false,
  user: null,
};

export const useLeadStore = create<LeadStore>((set) => ({
  currentStep: 1,
  formData: initialFormData,
  addressValidated: false,

  setEstimationType: (type) =>
    set((state) => ({
      formData: { ...state.formData, estimationType: type },
    })),

  setPropertyType: (type) =>
    set((state) => ({
      formData: { ...state.formData, propertyType: type },
    })),

  setAddress: (address, validated, inseeCode) =>
    set((state) => ({
      formData: { ...state.formData, address, inseeCode },
      addressValidated: validated,
    })),

  setSurface: (surface) =>
    set((state) => ({
      formData: { ...state.formData, surface },
    })),

  setSurfaceRdc: (surfaceRdc) =>
    set((state) => ({
      formData: { ...state.formData, surfaceRdc },
    })),

  setSurfaceSousSol: (surfaceSousSol) =>
    set((state) => ({
      formData: { ...state.formData, surfaceSousSol },
    })),

  setFloor: (floor) =>
    set((state) => ({
      formData: { ...state.formData, floor },
    })),

  setIsNewProperty: (isNewProperty) =>
    set((state) => ({
      formData: { ...state.formData, isNewProperty },
    })),

  setUser: (user) =>
    set((state) => ({
      formData: { ...state.formData, user },
    })),

  nextStep: () =>
    set((state) => ({
      currentStep: Math.min(state.currentStep + 1, 6),
    })),

  previousStep: () =>
    set((state) => ({
      currentStep: Math.max(state.currentStep - 1, 1),
    })),

  goToStep: (step) =>
    set(() => ({
      currentStep: step,
    })),

  resetForm: () =>
    set(() => ({
      currentStep: 1,
      formData: initialFormData,
      addressValidated: false,
    })),
}));
